import { RootState } from '../reducers'

export const selectIsOptionKey = (gamerIndex: number) => (state: RootState) =>
  state.settings.viewSettings[gamerIndex].isOptionKey
export const selectViewSettings = (gamerIndex: number) => (state: RootState) =>
  state.settings.viewSettings[gamerIndex]
export const selectIsHidingLeaderboardResults = (state: RootState) =>
  state.settings.isHidingLeaderboardResults
